import type { StepperNode } from '../pipeline'

/** Pill row: Prospect → Contacted → Proposal → Won/Lost. */
export function ProcessStepper({ steps }: { steps: StepperNode[] }) {
  return (
    <div className="stepper" aria-label="Pipeline progress">
      {steps.map((s, i) => (
        <div className="stepper__node" key={`${s.label}-${i}`}>
          <div className="stepper__pill" style={{ background: s.bg, borderColor: s.border }}>
            <span className="stepper__dot" style={{ background: s.dot }} />
            <span className="stepper__label" style={{ color: s.text }}>
              {s.label}
            </span>
          </div>
          {s.hasArrow && <span className="stepper__arrow">→</span>}
        </div>
      ))}
    </div>
  )
}
